import {
  Component,
  Element,
  Event,
  EventEmitter,
  h,
  Prop,
} from "@stencil/core";
import { componentsReady } from "@porsche-design-system/components-js";
import { navContentStore } from "@phn/state/nav-content-store";
import {
  NavigationMode,
  NavigationModeType,
  NavigationTheme,
  NavigationThemeType,
} from "@phn/utility/constants";
import { getRightTheme, isDesktop } from "@phn/utility/helper";
import {
  getLogoAriaLabel,
  getLogoLink,
  sendLogoDataLayerEvent,
} from "@phn/utility/logo";
import { navStateStore } from "@phn/state/nav-state-store";
import { ApplicationType } from "../../components";

@Component({
  tag: "phn-logo",
  styleUrl: "logo.scss",
  scoped: true,
})
export class Logo {
  @Prop() size!: string;

  @Prop() app!: ApplicationType;

  @Prop() theme: NavigationThemeType = NavigationTheme.light;

  @Prop() mode: NavigationModeType = NavigationMode.navbar;

  @Prop() breakpoint!: number;

  @Event() logoLoaded!: EventEmitter<void>;

  @Element() el!: HTMLPhnLogoElement;

  /* istanbul ignore next */
  componentWillLoad(): void {
    componentsReady(this.el) // TR: I believe this first call waits for the phn-logo element to be ready
      .then(async () => componentsReady(this.el)) // TR: Then this second call actually waits for its children (i.e.: phn-p-marque) to be ready
      .then(() => {
        this.logoLoaded.emit();
      })
      .catch(() => {
        this.logoLoaded.emit();
      });
  }

  render(): HTMLPhnLogoElement {
    const { locale } = navStateStore.state;
    const { crest, shop, level0 } = navContentStore.state;

    const logoLink = getLogoLink(locale, this.app, crest, shop);
    const logoAriaLabel = getLogoAriaLabel(locale, this.app, shop, level0);

    return isDesktop(this.breakpoint) ? (
      <phn-p-wordmark
        onClick={() => {
          if (crest) sendLogoDataLayerEvent(crest);
        }}
        href={logoLink}
        aria={crest ? { "aria-label": logoAriaLabel } : undefined}
        size="small"
        theme={getRightTheme(this.theme, this.mode)}
      />
    ) : (
      <phn-p-crest
        onClick={() => {
          if (crest) sendLogoDataLayerEvent(crest);
        }}
        href={logoLink}
        aria={crest ? { "aria-label": logoAriaLabel } : undefined}
      />
    );
  }
}
